import { z } from 'zod'

export const analyticsProviderKeySchema = z.enum(['umami', 'plausible', 'matomo', 'ga4'])

export const analyticsConsentCategorySchema = z.enum(['analytics', 'marketing'])

export const analyticsProviderConfigItemSchema = z.object({
  key: analyticsProviderKeySchema,
  category: analyticsConsentCategorySchema,
  requires_consent: z.boolean(),
  config: z.record(z.string(), z.union([z.string(), z.number(), z.boolean()])),
})

export const analyticsConfigResponseSchema = z.object({
  data: z.array(analyticsProviderConfigItemSchema),
})

export type AnalyticsProviderKey = z.infer<typeof analyticsProviderKeySchema>
export type AnalyticsConsentCategory = z.infer<typeof analyticsConsentCategorySchema>
export type AnalyticsProviderConfigItem = z.infer<typeof analyticsProviderConfigItemSchema>
